import React, { useEffect, forwardRef } from 'react';
import styles from './ModalInner.module.scss';

const ModalInner = forwardRef(
    (
        {
            isVisible,
            width,
            minWidth,
            maxWidth,
            overflow,
            textAlign,
            contentPadding: padding,
            ...props
        },
        ref
    ) => {
        useEffect(() => {
            if (isVisible) {
                document.getElementById('app-container').style.filter = 'blur(16px)';
            }
            return () => {
                document.getElementById('app-container').style.filter = 'blur(0)';
            };
        }, [isVisible]);

        return (
            <div className={`${styles.modal} ${!isVisible ? 'd-hidden' : ''}`}>
                <div
                    className={styles.modalContent}
                    ref={ref}
                    style={{
                        width,
                        minWidth,
                        maxWidth,
                        textAlign,
                        padding,
                        overflow,
                    }}
                >
                    {props.children}
                </div>
            </div>
        );
    }
);

export default ModalInner;
